module.exports = __webpack_public_path__ + "img/2.342db1a4.png";